(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mhc-ui-components", [], factory);
	else if(typeof exports === 'object')
		exports["mhc-ui-components"] = factory();
	else
		root["mhc-ui-components"] = factory();
})(global, () => {
return 